import { memo, useState } from 'react'
import { Folder, FileAudio, FileVideo } from 'lucide-react'
import type { MediaFile } from '../../lib/mediaBrowserApi.js'
import { mediaLibraryApi } from '../../lib/api.js'
import { formatBytesFr } from './mediaLibraryFormat.js'

const IMAGE_RE = /\.(png|jpe?g|gif|webp|bmp|svg)$/i
const AUDIO_RE = /\.(wav|mp3|flac|aac|m4a|ogg|aiff?)$/i

interface MediaCardProps {
  file:          MediaFile
  selected:      boolean
  onClick:       () => void
  onDoubleClick: () => void
}

/** Vignette de la vue grille : image réelle pour les images, carte pour le reste. */
export const MediaCard = memo(function MediaCard({ file, selected, onClick, onDoubleClick }: MediaCardProps) {
  const [imgErr, setImgErr] = useState(false)
  const isDir   = file.type === 'directory'
  const isImage = !isDir && IMAGE_RE.test(file.name)
  const ext     = (file.ext || '').replace('.', '').toUpperCase()

  return (
    <button
      type="button"
      className={`media-card${selected ? ' is-selected' : ''}`}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      aria-pressed={selected}
      title={file.name}
    >
      <span className={`media-card__thumb media-card__thumb--${isDir ? 'dir' : isImage ? 'image' : 'file'}`}>
        {isDir ? (
          <Folder size={26} aria-hidden />
        ) : isImage && !imgErr ? (
          <img
            className="media-card__img"
            src={mediaLibraryApi.streamUrl(file.relativePath)}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setImgErr(true)}
          />
        ) : (
          <span className="media-card__glyph">
            {AUDIO_RE.test(file.name) ? <FileAudio size={22} aria-hidden /> : <FileVideo size={22} aria-hidden />}
            {ext && <span className="media-card__ext">{ext}</span>}
          </span>
        )}
      </span>
      <span className="media-card__foot">
        <span className="media-card__name">{file.name}</span>
        <span className="media-card__sub">{isDir ? 'Dossier' : formatBytesFr(file.size)}</span>
      </span>
    </button>
  )
})
